/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type HpRespLocationsModule_viewer = {
    readonly regionalInfo?: ReadonlyArray<{
        readonly locationPage: {
            readonly __typename: string;
            readonly title: string | null;
            readonly linkData: {
                readonly path: string | null;
                readonly " $fragmentRefs": FragmentRefs<"SeoLink_linkData">;
            };
        } | null;
    } | null> | null;
    readonly " $fragmentRefs": FragmentRefs<"HpRespLocationItems_viewer">;
    readonly " $refType": "HpRespLocationsModule_viewer";
};
export type HpRespLocationsModule_viewer$data = HpRespLocationsModule_viewer;
export type HpRespLocationsModule_viewer$key = {
    readonly " $data"?: HpRespLocationsModule_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"HpRespLocationsModule_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "HpRespLocationsModule_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "zipCode",
      "type": "String"
    },
    {
      "kind": "RootArgument",
      "name": "userCountryCode",
      "type": "String"
    },
    {
      "kind": "RootArgument",
      "name": "isClient",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "isClient",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "regionalInfo",
          "storageKey": null,
          "args": [
            {
              "kind": "Variable",
              "name": "countryCode",
              "variableName": "userCountryCode"
            },
            {
              "kind": "Literal",
              "name": "regionTypes",
              "value": "ITEM_LOCATION"
            },
            {
              "kind": "Variable",
              "name": "zipCode",
              "variableName": "zipCode"
            }
          ],
          "concreteType": "RegionalInfo",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "locationPage",
              "storageKey": null,
              "args": null,
              "concreteType": "LocationPage",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "__typename",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": "title",
                  "name": "displayName",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "linkData",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "LinkData",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "path",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "FragmentSpread",
                      "name": "SeoLink_linkData",
                      "args": null
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "HpRespLocationItems_viewer",
      "args": null
    }
  ]
};
(node as any).hash = '704abd02f2de7708302b87779567b32c';
export default node;
